import React, { useState, useEffect } from 'react';
import {
  Dialog,
  Box,
  DialogTitle,
  DialogContent,
  IconButton,
  Grid,
  TextField,
  Button,
  FormGroup,
  useTheme,
  DialogActions,
  DialogContentText,
  Slider,
  Typography,
  useMediaQuery,
  Switch,
  FormControlLabel,
  RadioGroup,
  Radio,
  FormControl,
  FormLabel,
  Checkbox,
  FormGroup as MuiFormGroup,
  Autocomplete,
  Paper,

  InputLabel,
  Select,
  MenuItem
} from '@mui/material';

import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

import CloseIcon from '@mui/icons-material/Close';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import RemoveIcon from '@mui/icons-material/Remove';
import { tokens } from "../../theme";
import { styled } from '@mui/material/styles';

import PdfThumbnail from '../../images/PdfThumbnail.png'; // import a component or image for PDF thumbnail
import GenericFileThumbnail from '../../images/GenericFileThumbnail.png'; // import a component or image for generic file thumbnail

import { collection, getDocs, where, query } from 'firebase/firestore';

import {db} from '../../firebaseConfig';

import { useUser } from "../../common/UserContext";

import { useApplicationMode } from "../../common/ApplicationModeContext";

const formatPhoneNumber = (value) => {
  if (!value) return value;
  const phoneNumber = value.replace(/[^\d]/g, '');
  const phoneNumberLength = phoneNumber.length;
  if (phoneNumberLength < 4) return phoneNumber;
  if (phoneNumberLength < 7) {
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
  }
  return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
};

const formatCurrencyInteger = (value) => {
  const result = value.replace(/[^0-9]/g, '');
  if (result.length === 0) return '';
  return `$${Number(result).toLocaleString()}`;
};

const formatCurrency = (value) => {

  if (value != null && value !=="")
  {
        value = value.toString();
        // Remove all non-numeric characters except for the decimal point
        let result = value.replace(/[^0-9.]/g, '');
      
        // If there are multiple decimal points, keep only the first one
        const parts = result.split('.');
        if (parts.length > 2) {
          result = parts[0] + '.' + parts.slice(1).join('');
        }
      
        // Allow at most two decimal places
        if (parts.length === 2 && parts[1].length > 2) {
        
          result = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1].substring(0, 2);
        } else if (parts.length === 2 && parts[1].length <= 2) 
        {
          result = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
        }else
        {
          result = result.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        }
        return result ? `$${result}` : '';

    } else 
    {
      return "";
    }
};

const formatDecimal = (value) => {

  if (value != null && value !=="")
  {
        value = value.toString();
        // Remove all non-numeric characters except for the decimal point
        let result = value.replace(/[^0-9.]/g, '');
      
        // If there are multiple decimal points, keep only the first one
        const parts = result.split('.');
        if (parts.length > 2) {
          result = parts[0] + '.' + parts.slice(1).join('');
        }
      
        // Allow at most two decimal places
        if (parts.length === 2 && parts[1].length > 2) {
        
          result = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1].substring(0, 2);
        } else if (parts.length === 2 && parts[1].length <= 2) 
        {
          result = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
        }else
        {
          result = result.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        }
        return result ? `${result}` : '';

    } else 
    {
      return "";
    }
};


const formatInteger = (value) => {

  if (value != null && value !=="")
  {
        value = value.toString();
        // Remove all non-numeric characters except for the decimal point
        let result = value.replace(/[^0-9]/g, '');
      
        result = result.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        
        return result ? `${result}` : '';

    } else 
    {
      return "";
    }
};

const NewStorageLocationModal = ({ isOpen, onClose, onSave, storageLocation }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const [maximized, setMaximized] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);

  const { appUserAccountNumber } = useUser();

  const { applicationMode } = useApplicationMode(); 
  
  const [location, setLocation] = useState('');
const [capacity, setCapacity] = useState('');
const [currentUtilization, setCurrentUtilization] = useState('');
const [temperature, setTemperature] = useState('');
const [humidity, setHumidity] = useState('');
const [managerId, setManagerId] = useState('');
const [managers, setManagers] = useState([]);
const [status, setStatus] = useState('');
const [lastInspectionDate, setLastInspectionDate] = useState('');
const [nextInspectionDueDate, setNextInspectionDueDate] = useState('');
const [remarks, setRemarks] = useState('');


  const [validationErrors, setValidationErrors] = useState({});
  const [fontSize, setFontSize] = useState(14);
  const [errorDialogOpen, setErrorDialogOpen] = useState(false);

  const CustomPaper = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === "dark" ? colors.greenAccent[700] : colors.greenAccent[700],
  }));

  // Add state for password visibility
  const [showPassword, setShowPassword] = useState(false);

  // Function to toggle password visibility
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  useEffect(() => {
    if (isOpen) {
      if (storageLocation) {
        setLocation(storageLocation.location);
setCapacity(formatDecimal(storageLocation.capacity.toString()));
setCurrentUtilization(formatDecimal(storageLocation.currentUtilization.toString()));
setTemperature(formatDecimal(storageLocation.temperature.toString()));
setHumidity(formatDecimal(storageLocation.humidity.toString()));
setManagerId(storageLocation.managerId || '');
setStatus(storageLocation.status);
setLastInspectionDate(storageLocation.lastInspectionDate?new Date(storageLocation.lastInspectionDate.seconds * 1000).toISOString().slice(0, 10):'');
setNextInspectionDueDate(storageLocation.nextInspectionDueDate?new Date(storageLocation.nextInspectionDueDate.seconds * 1000).toISOString().slice(0, 10):'');
setRemarks(storageLocation.remarks);

       
      } else {
        setLocation('');
setCapacity(0);
setCurrentUtilization(0);
setTemperature(0);
setHumidity(0);
setManagerId('');
setStatus('');
setLastInspectionDate('');
setNextInspectionDueDate('');
setRemarks('');

      }
      setValidationErrors({});
    }
  }, [isOpen, storageLocation]);

  
                useEffect(() => {
                    const fetchManagers = async () => {
                      const managersCollection = collection(db, 'employees');
                      const q = query(managersCollection, where("appAccountNumber", "==", appUserAccountNumber), where("applicationMode", "==", applicationMode));
                      const managersSnapshot = await getDocs(q);
                      const managersData = managersSnapshot.docs.map(doc => ({
                        id: doc.id,
                        name: doc.data().firstName+ " " +doc.data().lastName
                      }));
                      setManagers(managersData);
                    };
                
                    fetchManagers();
                  }, [appUserAccountNumber, applicationMode]);
                
                



  const increaseFontSize = () => {
    if (fontSize < 21) {
      setFontSize(fontSize + 1);
    }
  };

  const decreaseFontSize = () => {
    if (fontSize > 11) {
      setFontSize(fontSize - 1);
    }
  };

  const handleFieldChange = (setter, formatter) => (event) => {
    if (formatter != null) {
      setter(formatter(event.target.value));
    } else {
      setter(event.target.value);
    }
    setValidationErrors((prev) => ({ ...prev, [event.target.id]: false }));
  };

  const handleConfirmClose = () => {
    setConfirmOpen(false);
    onClose();
  };

  const handleCancelClose = () => {
    setConfirmOpen(false);
  };

  ;
      
      
  const handleSave = () => {
    const errors = {};

    if (!location) errors.location = true;
if (!capacity) errors.capacity = true;
if (!currentUtilization) errors.currentUtilization = true;
if (!temperature) errors.temperature = true;
if (!humidity) errors.humidity = true;
if (!managerId) errors.managerId = true;
if (!status) errors.status = true;


    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      setErrorDialogOpen(true);
      return;
    }

    const storageLocationEntry = {
      location,
capacity:capacity? parseFloat(capacity.replace(/[^0-9.]/g, '')) : 0,
currentUtilization:currentUtilization? parseFloat(currentUtilization.replace(/[^0-9.]/g, '')) : 0,
temperature:temperature? parseFloat(temperature.replace(/[^0-9.]/g, '')) : 0,
humidity:humidity? parseFloat(humidity.replace(/[^0-9.]/g, '')) : 0,
managerId,
status,
lastInspectionDate:convertDateToFirestoreTimestamp(lastInspectionDate),
nextInspectionDueDate:convertDateToFirestoreTimestamp(nextInspectionDueDate),
remarks,
appAccountNumber:appUserAccountNumber,
applicationMode:applicationMode
    };

    if (storageLocation != null && storageLocation.id != null) {
      storageLocationEntry.id = storageLocation.id;
    }

    onSave(storageLocationEntry);
    onClose();
  };

  

  
     const getExistingFileTotalSize = () => {

       let existingFilesTotalSize = 0;

    

    
      return existingFilesTotalSize;
    }

   

  
  const stringToColorLight = (str) => {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    let color = '#';
    for (let i = 0; i < 3; i++) {
      const value = (hash >> (i * 8)) & 0xFF;
      // Ensuring that the color values are always light by adding a base value of 127
      const lightValue = ((value + 127) % 128) + 127;
      color += ('00' + lightValue.toString(16)).substr(-2);
    }
    return color;
  };
  
  const stringToColorDark = (str) => {
  
    return stringToColorLight(str); // We will use the same colors
  };
  
  const stringToColorDarkOLD = (str) => {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    let color = '#';
    for (let i = 0; i < 3; i++) {
      const value = (hash >> (i * 8)) & 0xFF;
      // Ensuring that the color values are always dark by restricting them to the first half of 256
      const darkValue = value % 128;
      color += ('00' + darkValue.toString(16)).substr(-2);
    }
    return color;
  };
  

  
  const convertDateToFirestoreTimestamp = (dateString) => {

    if (dateString !== "" && dateString != null)
    {
        const date = new Date(dateString);
        if (isNaN(date.getTime())) {
          throw new Error("Invalid date format. Please use mm/dd/yyyy format.");
        }
        const seconds = Math.floor(date.getTime() / 1000);
        const nanoseconds = 0;
        return {
          seconds: seconds,
          nanoseconds: nanoseconds
        };
    } else 
    {
      return null;
    }
  };

  const convertTimeStringToFirestoreTimestamp = (timeString) => {

    if (timeString !== "" && timeString != null)
    {
        // Get the current date
        const now = new Date();
      
        // Extract hours and minutes from the time string
        const [hours, minutes] = timeString.split(':').map(Number);
      
        // Validate the time string
        if (isNaN(hours) || isNaN(minutes) || hours < 0 || hours > 23 || minutes < 0 || minutes > 59) {
          throw new Error("Invalid time format. Please use HH:mm format.");
        }
      
        // Set the hours and minutes on the current date
        now.setHours(hours);
        now.setMinutes(minutes);
        now.setSeconds(0);
        now.setMilliseconds(0);
      
        // Convert the Date object to seconds since Unix epoch
        const seconds = Math.floor(now.getTime() / 1000);
        const nanoseconds = 0;
      
        // Return the Firestore-like timestamp object
        return {
          seconds: seconds,
          nanoseconds: nanoseconds
        };
    } else 
    {
      return null;
    }
  };
  
  const convertFirestoreTimestampToTimeString = (timestamp) => {

    if (timestamp != null && timestamp !=="")
    {
        // Convert the seconds since Unix epoch to a Date object
        const date = new Date(timestamp.seconds * 1000);
      
        // Extract hours and minutes
        const hours = date.getHours();
        const minutes = date.getMinutes();
      
        // Format hours and minutes as a time string in "HH:mm" format
        const formattedHours = hours.toString().padStart(2, '0');
        const formattedMinutes = minutes.toString().padStart(2, '0');
      
        return `${formattedHours}:${formattedMinutes}`;
    } else 
    {
      return "";
    }
  };


  const getFileExtension = (fileName) => {
    return fileName.split('.').pop().toLowerCase();
  };

  const handleFileClick = (fileType,fileContent,fileName) => {
    if (fileType === 'pdf') {
      
      const base64String = fileContent.split(',')[1]; // Extract base64 string from data URL
      const byteCharacters = atob(base64String);
      const byteNumbers = new Array(byteCharacters.length);
  
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
  
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'application/pdf' });
      const blobUrl = URL.createObjectURL(blob);
  
      window.open(blobUrl, '_blank');

    } else if (['jpg', 'jpeg', 'png', 'gif'].includes(fileType)) {
      const image = new Image();
      image.src = fileContent;
    
      image.onload = () => {
        let width = image.naturalWidth;
        let height = image.naturalHeight;
        const padding = 50;
    
        // Get browser window dimensions
        const maxWidth = window.innerWidth - padding;
        const maxHeight = window.innerHeight - padding;
    
        // Resize the image if it's larger than the browser window
        if (width > maxWidth || height > maxHeight) {
          const widthRatio = maxWidth / width;
          const heightRatio = maxHeight / height;
          const minRatio = Math.min(widthRatio, heightRatio);
    
          width = Math.floor(width * minRatio);
          height = Math.floor(height * minRatio);
        }
    
        // Calculate the position to center the window
        const left = (window.screen.width / 2) - (width / 2);
        const top = (window.screen.height / 2) - (height / 2);
    
        // Open the window with the calculated position and size
        const w = window.open("", "", `width=${width + padding},height=${height + padding},left=${left},top=${top}`);
        image.style.width = `${width}px`;
        image.style.height = `${height}px`;
        w.document.write(image.outerHTML);
      };
        
    } else {
      const link = document.createElement('a');
      link.href = fileContent;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };
  
  const renderFileSize = (base64String) => {

    if (base64String != null)
    {
      const sizeInBytes = base64String.length * (3 / 4) - (base64String.indexOf('=') > 0 ? base64String.split('=').length - 1 : 0);
      const sizeInKB = sizeInBytes / 1024;
      const sizeInMB = sizeInKB / 1024;
    
      if (sizeInMB >= 1) {
        return <div style={{textAlign:'center'}}>{sizeInMB.toFixed(2)} MB</div>//`${sizeInMB.toFixed(2)} MB`;
      } else {
        return <div style={{textAlign:'center'}}>{sizeInKB.toFixed(2)} KB</div> //`${sizeInKB.toFixed(2)} KB`;
      }
    } else
    {
      return <div></div>;
    }
  };
  
  const renderThumbnail = (fileContent,fileName) => {
    if (!fileContent || !fileName) return null;
    const fileType = getFileExtension(fileName);
    if (fileType === 'pdf') {
      return <img src={PdfThumbnail} title={fileName} alt="PDF thumbnail" onClick={() => handleFileClick(fileType,fileContent,fileName)} style={{ cursor: 'pointer',height:'100px',width:'81px' }} />;
    } else if (['jpg', 'jpeg', 'png', 'gif'].includes(fileType)) {
      return <img src={fileContent} title={fileName} alt="Profile thumbnail" onClick={() => handleFileClick(fileType,fileContent,fileName)} style={{ cursor: 'pointer', maxWidth: '100px', maxHeight: '100px' }} />;
    } else {
      return <img src={GenericFileThumbnail} title={fileName} alt="File thumbnail" onClick={() => handleFileClick(fileType,fileContent,fileName)} style={{ cursor: 'pointer',height:'100px',width:'77px'  }} />;
    }
  };

  const colorFunction = theme.palette.mode === "dark" ? stringToColorDark : stringToColorLight;
  
  return (
    <>
      <Dialog
        open={isOpen}
        onClose={() => setConfirmOpen(true)}
        fullScreen={maximized}
        aria-labelledby="responsive-dialog-title"
        maxWidth="md"
        fullWidth
      >
        <DialogTitle sx={{ m: 0, p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: colors.inputModal.dialogHeaderBackgroundColor }}>
        <Box sx={{ color: (theme) => theme.palette.grey[100] }}>
            {storageLocation ? "Edit Storage Location : " +storageLocation.id : "Add New Storage Location"}
          </Box>
          <Box sx={{ flexGrow: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <IconButton aria-label="decrease font size" onClick={decreaseFontSize} sx={{ marginRight: 1, color: (theme) => theme.palette.grey[500] }}>
              <RemoveIcon />
            </IconButton>
            <IconButton aria-label="increase font size" onClick={increaseFontSize} sx={{ color: (theme) => theme.palette.grey[500] }}>
              <AddIcon />
            </IconButton>
          </Box>
          <Box>
            <IconButton
              aria-label={maximized ? "exit full screen" : "full screen"}
              onClick={() => setMaximized(!maximized)}
              sx={{ color: (theme) => theme.palette.grey[500] }}
            >
              {maximized ? <FullscreenExitIcon /> : <FullscreenIcon />}
            </IconButton>
            <IconButton
              aria-label="close"
              onClick={() => setConfirmOpen(true)}
              sx={{ color: (theme) => theme.palette.grey[500] }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>

        <DialogContent sx={{ backgroundColor: colors.inputModal.dialogContentBackgroundColor }}>
          <FormGroup>
            <Grid container spacing={2}>
            
            <Grid item xs={12} md={6}>

<TextField fullWidth margin="normal" id="location" label="Storage Location Name"  value={location} onChange={handleFieldChange(setLocation)} error={validationErrors.location}  inputProps={{ style: { fontSize }}} 
                    sx={{'& .MuiOutlinedInput-root': {
                            backgroundColor: colors.inputModal.inputBackgroundColor,
                        '& fieldset': {
                            borderColor: colors.inputModal.inputDefaultBorderColor}, 
                        '&:hover fieldset': {
                            borderColor: colors.inputModal.inputHoverBorderColor,
                            ...(theme.palette.mode !== 'dark' && {
                                boxShadow: '0 0 8px 2px rgba(0,255,0,0.3)',
                            }),
                            },
                        '&.Mui-focused fieldset': {
                            borderColor: colors.inputModal.inputFocusedBorderColor,
                            ...(theme.palette.mode !== 'dark' && {
                                boxShadow: '0 0 3px 1px blue',
                            }),
                            },},
                        '& .MuiInputLabel-root': {
                            color:colors.inputModal.inputDefaultBorderColor, 
                        '&:hover': {
                            color: colors.inputModal.inputHoverBorderColor,},
                        '&.Mui-focused': {
                            color: 'currentColor',},},}}/>
<TextField fullWidth margin="normal" id="capacity" label="Capacity (gallons)"  value={capacity} onChange={handleFieldChange(setCapacity, formatDecimal)} error={validationErrors.capacity}  inputProps={{ style: { fontSize }}} 
                    sx={{'& .MuiOutlinedInput-root': {
                            backgroundColor: colors.inputModal.inputBackgroundColor,
                        '& fieldset': {
                            borderColor: colors.inputModal.inputDefaultBorderColor}, 
                        '&:hover fieldset': {
                            borderColor: colors.inputModal.inputHoverBorderColor,
                            ...(theme.palette.mode !== 'dark' && {
                                boxShadow: '0 0 8px 2px rgba(0,255,0,0.3)',
                            }),
                            },
                        '&.Mui-focused fieldset': {
                            borderColor: colors.inputModal.inputFocusedBorderColor,
                            ...(theme.palette.mode !== 'dark' && {
                                boxShadow: '0 0 3px 1px blue',
                            }),
                            },},
                        '& .MuiInputLabel-root': {
                            color:colors.inputModal.inputDefaultBorderColor, 
                        '&:hover': {
                            color: colors.inputModal.inputHoverBorderColor,},
                        '&.Mui-focused': {
                            color: 'currentColor',},},}}/>


                    
                    <Slider
                        value={parseFloat(capacity.toString().replace(/[^0-9.]/g, '')) || 0}
                        onChange={(e, newValue) => setCapacity(formatDecimal(newValue.toString()))}
                        min={0}
                        max={5000}
                        step={50}
                        valueLabelDisplay="auto"
                        sx={{ marginY: 1, marginLeft:'5px', paddingTop :'0px',marginTop :'0px',color: colors.inputModal.inputDefaultBorderColor }}
                        />
                    
                        

                    <TextField fullWidth margin="normal" id="currentUtilization" label="Current Utilization (%)"  value={currentUtilization} onChange={handleFieldChange(setCurrentUtilization, formatDecimal)} error={validationErrors.currentUtilization}  inputProps={{ style: { fontSize }}} 
                    sx={{'& .MuiOutlinedInput-root': {
                            backgroundColor: colors.inputModal.inputBackgroundColor,
                        '& fieldset': {
                            borderColor: colors.inputModal.inputDefaultBorderColor}, 
                        '&:hover fieldset': {
                            borderColor: colors.inputModal.inputHoverBorderColor,
                            ...(theme.palette.mode !== 'dark' && {
                                boxShadow: '0 0 8px 2px rgba(0,255,0,0.3)',
                            }),
                            },
                        '&.Mui-focused fieldset': {
                            borderColor: colors.inputModal.inputFocusedBorderColor,
                            ...(theme.palette.mode !== 'dark' && {
                                boxShadow: '0 0 3px 1px blue',
                            }),
                            },},
                        '& .MuiInputLabel-root': {
                            color:colors.inputModal.inputDefaultBorderColor, 
                        '&:hover': {
                            color: colors.inputModal.inputHoverBorderColor,},
                        '&.Mui-focused': {
                            color: 'currentColor',},},}}/>


                    
                    <Slider
                        value={parseFloat(currentUtilization.toString().replace(/[^0-9.]/g, '')) || 0}
                        onChange={(e, newValue) => setCurrentUtilization(formatDecimal(newValue.toString()))}
                        min={0}
                        max={100}
                        step={5}
                        valueLabelDisplay="auto"
                        sx={{ marginY: 1, marginLeft:'5px', paddingTop :'0px',marginTop :'0px',color: colors.inputModal.inputDefaultBorderColor }}
                        />
                    
                        

                    <TextField fullWidth margin="normal" id="temperature" label="Temperature (degrees fahrenheit)"  value={temperature} onChange={handleFieldChange(setTemperature, formatDecimal)} error={validationErrors.temperature}  inputProps={{ style: { fontSize }}} 
                    sx={{'& .MuiOutlinedInput-root': {
                            backgroundColor: colors.inputModal.inputBackgroundColor,
                        '& fieldset': {
                            borderColor: colors.inputModal.inputDefaultBorderColor}, 
                        '&:hover fieldset': {
                            borderColor: colors.inputModal.inputHoverBorderColor,
                            ...(theme.palette.mode !== 'dark' && {
                                boxShadow: '0 0 8px 2px rgba(0,255,0,0.3)',
                            }),
                            },
                        '&.Mui-focused fieldset': {
                            borderColor: colors.inputModal.inputFocusedBorderColor,
                            ...(theme.palette.mode !== 'dark' && {
                                boxShadow: '0 0 3px 1px blue',
                            }),
                            },},
                        '& .MuiInputLabel-root': {
                            color:colors.inputModal.inputDefaultBorderColor, 
                        '&:hover': {
                            color: colors.inputModal.inputHoverBorderColor,},
                        '&.Mui-focused': {
                            color: 'currentColor',},},}}/>


                    
                    <Slider
                        value={parseFloat(temperature.toString().replace(/[^0-9.]/g, '')) || 0}
                        onChange={(e, newValue) => setTemperature(formatDecimal(newValue.toString()))}
                        min={32}
                        max={100}
                        step={1}
                        valueLabelDisplay="auto"
                        sx={{ marginY: 1, marginLeft:'5px', paddingTop :'0px',marginTop :'0px',color: colors.inputModal.inputDefaultBorderColor }}
                        />
                    
                        

                    <TextField fullWidth margin="normal" id="humidity" label="Humidity (%)"  value={humidity} onChange={handleFieldChange(setHumidity, formatDecimal)} error={validationErrors.humidity}  inputProps={{ style: { fontSize }}} 
                    sx={{'& .MuiOutlinedInput-root': {
                            backgroundColor: colors.inputModal.inputBackgroundColor,
                        '& fieldset': {
                            borderColor: colors.inputModal.inputDefaultBorderColor}, 
                        '&:hover fieldset': {
                            borderColor: colors.inputModal.inputHoverBorderColor,
                            ...(theme.palette.mode !== 'dark' && {
                                boxShadow: '0 0 8px 2px rgba(0,255,0,0.3)',
                            }),
                            },
                        '&.Mui-focused fieldset': {
                            borderColor: colors.inputModal.inputFocusedBorderColor,
                            ...(theme.palette.mode !== 'dark' && {
                                boxShadow: '0 0 3px 1px blue',
                            }),
                            },},
                        '& .MuiInputLabel-root': {
                            color:colors.inputModal.inputDefaultBorderColor, 
                        '&:hover': {
                            color: colors.inputModal.inputHoverBorderColor,},
                        '&.Mui-focused': {
                            color: 'currentColor',},},}}/>


                    
                    <Slider
                        value={parseFloat(humidity.toString().replace(/[^0-9.]/g, '')) || 0}
                        onChange={(e, newValue) => setHumidity(formatDecimal(newValue.toString()))}
                        min={0}
                        max={100}
                        step={5}
                        valueLabelDisplay="auto"
                        sx={{ marginY: 1, marginLeft:'5px', paddingTop :'0px',marginTop :'0px',color: colors.inputModal.inputDefaultBorderColor }}
                        />
                    
                        

                    <Autocomplete
                fullWidth
                margin="normal" 
                options={managers}
                getOptionLabel={(option) => option.name}
                renderInput={(params) => (
                  <TextField {...params} label="Manager"   error={validationErrors.managerId}  margin="normal" inputProps={{ ...params.inputProps, style: { fontSize } }} />
                )}
                PaperComponent={CustomPaper}
                value={managers.find(ref => ref.id === managerId) || null}
                onChange={(event, newValue) => setManagerId(newValue ? newValue.id : '')}
                sx={{'& .MuiOutlinedInput-root': {
                        backgroundColor: colors.inputModal.inputBackgroundColor,
                    '& fieldset': {
                        borderColor: colors.inputModal.inputDefaultBorderColor}, 
                    '&:hover fieldset': {
                        borderColor: colors.inputModal.inputHoverBorderColor,
                        ...(theme.palette.mode !== 'dark' && {
                            boxShadow: '0 0 8px 2px rgba(0,255,0,0.3)',
                        }),
                        },
                    '&.Mui-focused fieldset': {
                        borderColor: colors.inputModal.inputFocusedBorderColor,
                        ...(theme.palette.mode !== 'dark' && {
                            boxShadow: '0 0 3px 1px blue',
                        }),
                        },},
                    '& .MuiInputLabel-root': {
                        color:colors.inputModal.inputDefaultBorderColor, 
                    '&:hover': {
                        color: colors.inputModal.inputHoverBorderColor,},
                    '&.Mui-focused': {
                        color: 'currentColor',},},}}
              />
</Grid>

<Grid item xs={12} md={6}>


                <Autocomplete
                fullWidth
                margin="normal"
                options={[
                  "Active","Inactive"
                ]}
                renderInput={(params) => (
                  <TextField {...params} label="Status" margin="normal"   error={validationErrors.status}  inputProps={{ ...params.inputProps, style: { fontSize } }} />
                )}
                PaperComponent={CustomPaper}
                value={status}
                onChange={(event, newValue) => setStatus(newValue)} 
                sx={{'& .MuiOutlinedInput-root': {
                        backgroundColor: colors.inputModal.inputBackgroundColor,
                    '& fieldset': {
                        borderColor: colors.inputModal.inputDefaultBorderColor}, 
                    '&:hover fieldset': {
                        borderColor: colors.inputModal.inputHoverBorderColor,
                        ...(theme.palette.mode !== 'dark' && {
                            boxShadow: '0 0 8px 2px rgba(0,255,0,0.3)',
                        }),
                        },
                    '&.Mui-focused fieldset': {
                        borderColor: colors.inputModal.inputFocusedBorderColor,
                        ...(theme.palette.mode !== 'dark' && {
                            boxShadow: '0 0 3px 1px blue',
                        }),
                        },},
                    '& .MuiInputLabel-root': {
                        color:colors.inputModal.inputDefaultBorderColor, 
                    '&:hover': {
                        color: colors.inputModal.inputHoverBorderColor,},
                    '&.Mui-focused': {
                        color: 'currentColor',},},}}
              />
                

                <TextField
                fullWidth
                margin="normal"
                id="lastInspectionDate"
                label="Last Inspection Date"
                type="date" 
                InputLabelProps={{ shrink: true, style: { fontSize } }}
                value={lastInspectionDate}
                onChange={e => setLastInspectionDate(e.target.value)} 
                sx={{
                  '& .MuiOutlinedInput-root': {
                    backgroundColor: colors.inputModal.inputBackgroundColor, 
                    '& fieldset': {borderColor: colors.inputModal.inputDefaultBorderColor}, 
                    '&:hover fieldset': {
                      borderColor: colors.inputModal.inputHoverBorderColor,
                      ...(theme.palette.mode !== 'dark' && {
                            boxShadow: '0 0 8px 2px rgba(0,255,0,0.3)',
                        }),
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: colors.inputModal.inputFocusedBorderColor,
                      ...(theme.palette.mode !== 'dark' && {
                            boxShadow: '0 0 3px 1px blue',
                        }),
                    },
                  },
                  '& .MuiInputLabel-root': {
                    color:colors.inputModal.inputDefaultBorderColor, 
                    '&:hover': {
                      color: colors.inputModal.inputHoverBorderColor,
                    },
                    '&.Mui-focused': {
                      color: 'currentColor',
                    },
                  },
                  '& .MuiSvgIcon-root': {
                    color: theme.palette.mode === 'dark' ? colors.greenAccent[600] : colors.greenAccent[400],
                  },
                  '& input::-webkit-calendar-picker-indicator': {
                    filter: theme.palette.mode === 'dark' ? 'invert(35%) sepia(63%) saturate(3186%) hue-rotate(110deg) brightness(90%) contrast(92%)' : 'invert(46%) sepia(83%) saturate(748%) hue-rotate(87deg) brightness(93%) contrast(90%)',
                  },
                }}
             />
                

                <TextField
                fullWidth
                margin="normal"
                id="nextInspectionDueDate"
                label="Next Inspection Due Date"
                type="date" 
                InputLabelProps={{ shrink: true, style: { fontSize } }}
                value={nextInspectionDueDate}
                onChange={e => setNextInspectionDueDate(e.target.value)} 
                sx={{
                  '& .MuiOutlinedInput-root': {
                    backgroundColor: colors.inputModal.inputBackgroundColor, 
                    '& fieldset': {borderColor: colors.inputModal.inputDefaultBorderColor}, 
                    '&:hover fieldset': {
                      borderColor: colors.inputModal.inputHoverBorderColor,
                      ...(theme.palette.mode !== 'dark' && {
                            boxShadow: '0 0 8px 2px rgba(0,255,0,0.3)',
                        }),
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: colors.inputModal.inputFocusedBorderColor,
                      ...(theme.palette.mode !== 'dark' && {
                            boxShadow: '0 0 3px 1px blue',
                        }),
                    },
                  },
                  '& .MuiInputLabel-root': {
                    color:colors.inputModal.inputDefaultBorderColor, 
                    '&:hover': {
                      color: colors.inputModal.inputHoverBorderColor,
                    },
                    '&.Mui-focused': {
                      color: 'currentColor',
                    },
                  },
                  '& .MuiSvgIcon-root': {
                    color: theme.palette.mode === 'dark' ? colors.greenAccent[600] : colors.greenAccent[400],
                  },
                  '& input::-webkit-calendar-picker-indicator': {
                    filter: theme.palette.mode === 'dark' ? 'invert(35%) sepia(63%) saturate(3186%) hue-rotate(110deg) brightness(90%) contrast(92%)' : 'invert(46%) sepia(83%) saturate(748%) hue-rotate(87deg) brightness(93%) contrast(90%)',
                  },
                }}
             />
                
</Grid>


            
            </Grid>
              
            
                <TextField
                fullWidth
                margin="normal"
                id="remarks" 
                error={validationErrors.remarks} 
                label="Remarks"
                multiline
                rows={4}
                value={remarks}
                onChange={handleFieldChange(setRemarks)}
                inputProps={{ style: { fontSize } }} 
                sx={{'& .MuiOutlinedInput-root': {
                        backgroundColor: colors.inputModal.inputBackgroundColor,
                    '& fieldset': {
                        borderColor: colors.inputModal.inputDefaultBorderColor}, 
                    '&:hover fieldset': {
                        borderColor: colors.inputModal.inputHoverBorderColor,
                        ...(theme.palette.mode !== 'dark' && {
                            boxShadow: '0 0 8px 2px rgba(0,255,0,0.3)',
                        }),
                        },
                    '&.Mui-focused fieldset': {
                        borderColor: colors.inputModal.inputFocusedBorderColor,
                        ...(theme.palette.mode !== 'dark' && {
                            boxShadow: '0 0 3px 1px blue',
                        }),
                        },},
                    '& .MuiInputLabel-root': {
                        color:colors.inputModal.inputDefaultBorderColor, 
                    '&:hover': {
                        color: colors.inputModal.inputHoverBorderColor,},
                    '&.Mui-focused': {
                        color: 'currentColor',},},}}
                />
                    


          </FormGroup>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
            <Button variant="contained" onClick={handleSave} sx={{ backgroundColor: colors.greenAccent[600], color: colors.primary[100],'&:hover': { backgroundColor: colors.greenAccent[800] } }}>Save</Button>
          </Box>
        </DialogContent>
      </Dialog>

      <Dialog
        open={confirmOpen}
        onClose={handleCancelClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" sx={{ backgroundColor: colors.greenAccent[700] }}>{"Confirm"}</DialogTitle>
        <DialogContent sx={{ backgroundColor: colors.greenAccent[700] }}>
          <DialogContentText id="alert-dialog-description">
            Sure you want to close without saving changes?
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ backgroundColor: colors.greenAccent[700] }}>
          <Button onClick={handleCancelClose} sx={{ backgroundColor: colors.greenAccent[600], color: colors.primary[100],'&:hover': { backgroundColor: colors.greenAccent[800] } }}>
            No
          </Button>
          <Button onClick={handleConfirmClose} sx={{ backgroundColor: colors.greenAccent[600], color: colors.primary[100],'&:hover': { backgroundColor: colors.greenAccent[800] } }} autoFocus>
            Yes
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={errorDialogOpen}
        onClose={() => setErrorDialogOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" sx={{ backgroundColor: colors.greenAccent[700] }}>{"Validation Error"}</DialogTitle>
        <DialogContent sx={{ backgroundColor: colors.greenAccent[700] }}>
          <DialogContentText id="alert-dialog-description">
            Please fill all required fields.
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ backgroundColor: colors.greenAccent[700] }}>
          <Button onClick={() => setErrorDialogOpen(false)} sx={{ backgroundColor: colors.greenAccent[600], color: colors.primary[100],'&:hover': { backgroundColor: colors.greenAccent[800] } }} autoFocus>
            Okay
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default NewStorageLocationModal;
